// @flow
import { createAction } from 'redux-act';

export const setPositions = createAction('Set Positions');


// WEBPACK FOOTER //
// ./src/modules/actions/positions.js